var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 11.5C19.0584 11.5 5.75 26.9272 5.75 34.5C5.75 42.0728 19.0584 57.5 34.5 57.5C49.9416 57.5 63.25 42.0728 63.25 34.5C63.25 26.9272 49.9416 11.5 34.5 11.5ZM34.5 51.75C21.85 51.75 11.5 38.7263 11.5 34.5C11.5 30.2737 21.85 17.25 34.5 17.25C47.15 17.25 57.5 30.2737 57.5 34.5C57.5 38.7263 47.15 51.75 34.5 51.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 46C40.8513 46 46 40.8513 46 34.5C46 28.1487 40.8513 23 34.5 23C28.1487 23 23 28.1487 23 34.5C23 40.8513 28.1487 46 34.5 46Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenEyeIcon);
export default __webpack_public_path__ + "static/media/openEyeIcon.a2d68d31d4f41a241799a9f653f8227d.svg";
export { ForwardRef as ReactComponent };